




















































































































import KamigameVue from '@/KamigameVue';
import Component from 'vue-class-component';
import { Mapper, BaseMapper } from '@azure/ms-rest-js';

import { FinalForm, FinalField } from 'vue-final-form';
import { V1CreateWikiRequest } from '@/api-client/generated/models/mappers';

@Component({
  name: 'wiki-create',
  components: {
    FinalForm,
    FinalField,
  },
})
export default class WikiCreate extends KamigameVue {
  term: string =
    '神ゲー攻略 Wiki 利用規約\n\n私はその人を常に先生と呼んでいた。だからここでもただ先生と書くだけで本名は打ち明けない。これは世間を憚かる遠慮というよりも、その方が私にとって自然だからである。私はその人の記憶を呼び起すごとに、すぐ「先生」といいたくなる。筆を執っても心持は同じ事である。よそよそしい頭文字などはとても使う気にならない。私が先生と知り合いになったのは鎌倉である。その時私はまだ若々しい書生であった。暑中休暇を利用して海水浴に行った友達からぜひ来いという端書を受け取ったので、私は多少の金を工面して、出掛ける事にした。私は金の工面に二、三日を費やした。ところが私が鎌倉に着いて三日と経たないうちに、私を呼び寄せた友達は、急に国元から帰れという電報を受け取った。電報には母が病気だからと断ってあったけれども友達はそれを信じなかった。友達はかねてから国元にいる親たちに勧まない結婚を強いられていた。彼は現代の習慣からいうと結婚するにはあまり年が若過ぎた。それに肝心の当人が気に入らなかった。それで夏休みに当然帰るべきところを、わざと避けて東京の近くで遊んでいたのである。彼は電報を私に見せてどうしようと相談をした。私にはどうしていいか分らなかった。けれども実際彼の母が病気であるとすれば彼は固より帰るべきはずであった。それで彼はとうとう帰る事になった。せっかく来た私は一人取り残された。学校の授業が始まるにはまだ大分日数があるので鎌倉におってもよし、帰ってもよいという境遇にいた私は、当分元の宿に留まる覚悟をした。友達は中国のある資産家の息子で金に不自由のない男であったけれども、学校が学校なのと年が年なので、生活の程度は私とそう変りもしなかった。したがって一人ぼっちになった私は別に恰好な宿を探す面倒ももたなかったのである。宿は鎌倉でも辺鄙な方角にあった。玉突きだのアイスクリームだのというハイカラなものには長い畷を一つ越さなければ手が届かなかった。車で行っても二十銭は取られた。けれども個人の別荘はそこここにいくつでも建てられていた。それに海へはごく近いので海水浴をやるには至極便利な地位を占めていた。私は毎日海へはいりに出掛けた。古い燻ぶり返った藁葺の間を通り抜けて磯へ下りると、この辺にこれほどの都会人種が住んでいるかと思うほど、避暑に来た男や女で砂の上が動いていた。ある時は海の中が銭湯のように黒い頭でごちゃごちゃしている事もあった。その中に知った人を一人ももたない私も、こういう賑やかな景色の中に裹まれて、砂の上に寝そべってみたり、膝頭を波に打たしてそこいらを跳ね廻るのは愉快であった。私は実に先生をこの雑沓の間に見付け出したのである。その時海岸には掛茶屋が二軒あった。私はふとした機会からその一軒の方に行き慣れていた。長谷辺に大きな別荘を構えている人と違って、各自に専有の着換場を拵えていないここいらの避暑客には、ぜひともこうした共同着換所といった風なものが必要なのであった。彼らはここで茶を飲み、ここで休息する外に、ここで海水着を洗濯させたり、ここで鹹はゆい身体を清めたり、ここへ帽子や傘を預けたりするのである。海水着を持たない私にも持物を盗まれる恐れはあったので、私は海へはいるたびにその茶屋へ一切を脱ぎ棄てる事にしていた。';

  name: string = '';
  game: string = '';
  title: string = '';
  description: string = '';
  termAccepted: boolean = false;

  error: boolean = false;
  errorMessage: string = '';

  getMapper(field: string): Mapper {
    const modelProperties = V1CreateWikiRequest.type.modelProperties;
    if (!modelProperties) {
      return {} as BaseMapper;
    }

    return modelProperties[field] || ({} as BaseMapper);
  }

  validateWikiName(value: string) {
    const mapper = this.getMapper('name');
    if (mapper) {
      mapper.constraints = Object.assign({}, mapper.constraints || {}, { Pattern: /^[0-9a-z\-]+$/ });
    }

    return this.validate(mapper, value, 'Wiki の URL', true);
  }

  async save(values: any, form: any, callback: any) {
    return this.api
      .createWiki(values)
      .then(() => {
        this.router.push({
          name: 'wiki_dashboard',
          params: { name: values.name },
        });
      })
      .catch((e: Error) => {
        if (e.message.includes('already exists')) {
          return { FORM_ERROR: '入力された URL はすでに取得されています。' };
        }

        return {
          FORM_ERROR: 'データ送信時にエラーが発生しました。恐れ入りますがしばらく経ってからもう一度お試しください。',
        };
      });
  }
}
